import { render } from "./AuditReport.vue?vue&type=template&id=5811ce4b"
import script from "./AuditReport.vue?vue&type=script&lang=js"
export * from "./AuditReport.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abola\\Documents\\A.Personal Dev\\CHI\\assetmentainance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__